const namespaced = true;

export const getters = {
  selectedOptions: state => {
    const selectedValues = state.value ? state.value.split(',').map(value => parseInt(value, 10)) : [];

    return state.options.filter(option => selectedValues.includes(option.id));
  },
  humanReadableValue: (state, gttrs) => {
    return gttrs.selectedOptions.map(option => option.name).join(', ');
  },
};

export const mutations = {
  SET_OPTIONS(state, { options }) {
    state.options = options;
  },

  SET_VALUE(state, { value }) {
    state.value = value;
  },

  RESET(state) {
    state.value = null;
  },
};

const state = {
  key: 'feature_groups',
  name: 'Group',
  options: [],
  value: null,
};

export default {
  namespaced,
  state,
  getters,
  mutations,
};
